module.exports = __webpack_public_path__ + "static/media/logo_sekolah_kembang.235f890a.png";